import React  from 'react';
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment, OutlinedInput } from "@mui/material"
import { useState } from "react";
import { useRecoilValue } from "recoil";
import useSavePatient from "src/Patient/hooks/useSavePatient";
import { valuesFormRegisterState } from "src/Patient/state/atoms";
import InputLabelCustom from "src/shared/components/forms/InputLabelCustom"

const PasswordRepeatField = () => {
    const { uswRepetirClave } = useRecoilValue(valuesFormRegisterState);
    const { handleChange } = useSavePatient();
    const [showPasswordRepeat, setShowPasswordRepeat] = useState(false)
    const handleClickShowPassword = () => {
        setShowPasswordRepeat(!showPasswordRepeat);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <>
            <InputLabelCustom htmlFor="input-password-repeat" text="Confirme Contraseña" />
            <OutlinedInput
                id="input-password-repeat"
                size="small"
                style={{ width: '100%' }}
                name="uswRepetirClave"
                type={showPasswordRepeat ? 'text' : 'password'}
                value={uswRepetirClave || ""}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                        >
                            {showPasswordRepeat ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                }
                onChange={(ev) => {
                    handleChange(ev);
                }}
                autoComplete="off"
            />
        </>
    )
}

export default PasswordRepeatField;